var map = {
	"./caishijie/helper2.png": "b7e7",
	"./caishuju/helper2.png": "1c5d",
	"./cqssc/helper2.png": "4fba",
	"./gd10/helper2.png": "6632",
	"./liuhe/helper2.png": "515d",
	"./madou/helper2.png": "0f01",
	"./pcdd/helper2.png": "23a6",
	"./pk10/helper2.png": "085c",
	"./xyft/helper2.png": "49dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca3d";